import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { ensureAccountLoadedOnce } from '@/lib/ensureAccountLoadedOnce';
import store from '@/store';

export async function accountBootstrapBeforeEach(
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> {
  await ensureAccountLoadedOnce(store, to.matched);
  next();
}
